import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Home = () => {
  return (
    <>
      <section className="home-6" id="home">
        <div className="bg-overlay"></div>
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="home-heading text-center">
                <h1 className="home-title">
                  Empowering Managers Inspiring Employees
                </h1>
                <p className="home-desc py-3 font-weight-bold">
                  Redefine how managers connect with their employees. 
                  <br></br>                  
                  Empower managers with actionable opportunities to deepen
                  relationships, foster engagement, and ensure every individual
                  feels valued and seen.
                  <br></br>
                   Join us to transform your workplace
                  into a thriving environment driven by meaningful connections
                  and collaborations.
                </p>

                <div className="btns-group mb-25"></div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Home;
